import { TextId, useTextsV2 } from '../../utils/useTexts'
import { useAppSelector } from '../../store/hooks'
import { getMarketSettingsState } from '../../store/appSlice'
import {
  getRfqOrEysButtonEnabled,
  getStartupData,
} from '../../store/sessionDataSlice'

export interface RfqEysButtonState {
  rfqOrEysButtonHidden: boolean
  rfqOrEysButtonText: string
  rfqOrEysButtonEnabled: boolean
}

// The same button is used for Explore Your Scania and for Request a quote.
export function useRfqEysButtonState(): RfqEysButtonState {
  const marketSettings = useAppSelector(getMarketSettingsState)
  const t2 = useTextsV2()
  const startupData = useAppSelector(getStartupData)
  const exploreYourScaniaMode = startupData?.exploreYourScaniaMode || false
  const rfqOrEysButtonEnabled = useAppSelector(getRfqOrEysButtonEnabled)

  const rfqOrEysButtonText = exploreYourScaniaMode
    ? t2(TextId.EYS_SEND_CHANGES_BUTTON)
    : t2(TextId.ACTION_LABEL_GET_CONSULTATION)

  let rfqOrEysButtonHidden = false
  if (!exploreYourScaniaMode) {
    if (marketSettings?.rfqEnabled === false) {
      rfqOrEysButtonHidden = true
    }
  }

  return { rfqOrEysButtonHidden, rfqOrEysButtonText, rfqOrEysButtonEnabled }
}
